import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
    InputField,
    Pagination,
} from "../../../../../components/common";
import FAQuesGrid from "./components/FAQuesGrid";
import { faqsActions } from "../../../../../store/faq/faqActions";
import Loader from "../../../../../components/common/Loader";
import GridSearchFilter, { AutoComplete, FilterAutoComplete, SelectedChiptItems, SelectedDateChip } from "../../../../../components/common/FilterLayout/GridFilter";
import {
    Accordion,
    AccordionSummary,
    Button,
    IconButton,
    Typography,
} from "@material-ui/core";
import { ExpandMore, MoreHoriz } from "@material-ui/icons";
import { ChipItem } from "../../Conversations/ConverstionSettings/GridFilter";
import { useDebounce } from "../../../../../utils/use-debounce";
import { toast } from "react-toastify";

const priorityList = [
    { name: 'Highest', id: 1 },
    { name: 'High Medium', id: 2 },
    { name: 'Medium', id: 3 },
    { name: 'Low Medium', id: 4 },
    { name: 'Lowest', id: 5 },
];

const FAQDataView = () => {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const [faqsData, setFaqsData] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [showFilterCounter, setShowFilterCounter] = useState(0);
    const [filters, setFilters] = useState({
        categoryId: null,
        question: "",
        name: "",
        priority: 0,
        platForm: [],
    });
    const { debouncedValue } = useDebounce(filters?.name)
    const [showFilters, setShowFilter] = useState(false);
    const [ totalCount , setTotalCount ] = useState(0);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [faqsCategoryData, setFaqsCategoryData] = useState([]);
    const [order, setOrderBy] = useState({
        orderByKey: "Id",
        orderVal: 0,
    });
    let filtersIndex = 0;
    const filtersLimit = 4;

    const platformOptions = [
        {
          id: 0,
          value: "Facebook",
        },
        {
          id: 1,
          value: "Instagram",
        },
        {
          id: 2,
          value: "Shopify",
        },
        {
          id: 3,
          value: "Accounts",
        },
        {
          id: 4,
          value: "IOS",
        },
        {
          id: 5,
          value: "Android",
        },
      ];

    const showFilter = () => {
        window.scroll(0, 0);
        setIsFilter(true);
    };

    const hideFilter = () => {
        setIsFilter(false);
    };

    useEffect(() => {
        setLoading(true)
        dispatch(
            faqsActions.onGetFaqCategories()
        ).then(data => {
            if (data?.data?.success) {
                setFaqsCategoryData(data?.data?.data)
            } else {
                setFaqsCategoryData([]);
            }
        });
        setLoading(false)
    }, [])

    const loadData = useCallback(() => {
        setLoading(true)
        dispatch(
            faqsActions.onGetAllFaqs({
                categoryId: filters?.categoryId,
                question: filters.question,
                search: debouncedValue,
                priority: filters.priority,
                platForm: platformOptions
                .filter(option => filters?.platForm?.includes(option.id))
                .map(option => option.value) || [],
                pagination: {
                    pageSize: rowsPerPage,
                    pageNo: page,
                    orderByKey: order.orderByKey,
                    orderByVal: order.orderVal,
                },
            })
        ).then(data => {
            if (data?.success) {
                setFaqsData(data?.data?.data?.items)
                if (data?.data?.data?.totalCount) {
                    setTotalCount(data?.data?.data?.totalCount);
                } else {
                    setTotalCount(0);
                }
                setLoading(false)
            }
            setLoading(false)
        });
    }, [dispatch, order.orderByKey, debouncedValue , order.orderVal, page, rowsPerPage]);

    useEffect(() => {
        loadData();
    }, [dispatch, loadData, page]);

    const filtersCount =
        (filters.question ? 1 : 0) +
        (filters.categoryId ? 1 : 0) +
        (filters.priority > 0 ? 1 : 0) +
        (filters.platForm?.length || 0);

    const applyFilters = () => {
        setLoading(true);
        setShowFilterCounter(filtersCount);
        hideFilter();
        if (page === 1) {
            dispatch(
                faqsActions.onGetAllFaqs({
                    pagination: {
                        pageSize: rowsPerPage,
                        pageNo: page,
                        orderByKey: order.key,
                        orderByVal: order.val,
                    },
                    categoryId: filters?.categoryId,
                    question: filters.question,
                    search: debouncedValue,
                    priority: filters.priority,
                    platForm: platformOptions
                    .filter(option => filters?.platForm?.includes(option.id))
                    .map(option => option.value) || [],
                })
            ).then(data => {
                if (data?.success) {
                    setFaqsData(data?.data?.data?.items);
                    setTotalCount(data?.data?.data?.totalCount);
                } else {
                    setFaqsData([]);
                    setTotalCount(0);
                }
                setLoading(false);
            });
        }
    };

    const onClearButtonPress = () => {
        setLoading(true);
        setPage(1);
        setRowsPerPage(10);
        setShowFilterCounter(0);
        setFilters({
            categoryId: 0,
            question: "",
            name: "",
            priority: 0,
            platForm: [],
        });
        dispatch(
            faqsActions.onGetAllFaqs({
                categoryId: 0,
                question: "",
                search: "",
                platForm: [],
                pagination: {
                    pageSize: 10,
                    pageNo: 1,
                    orderByKey: "Id",
                    orderByVal: 0,
                },
            })
        ).then(data => {
            if (data?.success) {
                setFaqsData(data?.data?.data?.items)
                if (data?.data?.data?.totalCount) {
                    setTotalCount(data?.data?.data?.totalCount);
                } else {
                    setTotalCount(0);
                }
                setLoading(false)
            }
            setLoading(false)
        });
    };

    useEffect(() => {
        setPage(1);
    }, [rowsPerPage]);

    const onDeleteFaq = (id) => {
        setLoading(true);
        dispatch(
            faqsActions.onDeleteFaq(id)
        ).then(res => {
            setLoading(true);
            if(res.success){
                toast.success("The FAQ has been deleted successfully.")
                dispatch(faqsActions.selectAllFaqs([]));
                loadData();
            }
            setLoading(false);
        });
    }

    return (
        <div
            className='gridBody contentBody businessCustomerGrid'
            style={{
                paddingRight: "20px !important"
            }}>
            {isLoading ? <Loader /> : null}
            <GridSearchFilter
                isFilterAdded={true}
                setFilters={setFilters}
                filters={filters}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                title={"FAQs Filter"}
                isFilter={isFilter}
                showFilter={showFilter}
                hideFilter={hideFilter}
                applyFilters={applyFilters}
                showFilterCounter={showFilterCounter}>
                <Accordion
                    defaultExpanded
                    id='end-user-filter-expandable'
                    TransitionProps={{ unmountOnExit: true }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography>
                            <span>Active Filter(s)</span>
                            <span>
                                <Button
                                    className='filterClearBtn filterClearBtnStyle'
                                    variant='outlined'
                                    onClick={() => {
                                        hideFilter();
                                        onClearButtonPress();
                                    }}>
                                    Clear
                                </Button>
                            </span>
                        </Typography>
                    </AccordionSummary>
                    <div style={{ marginBottom: "10px" }}>
                        {filtersCount <= 0 && (
                            <div className={`filtersChips`}>No Active Filter(s)</div>
                        )}
                    </div>

                    {filters.question?.length > 0 &&
                        (filtersIndex <= filtersLimit ||
                            (filtersIndex > filtersLimit && showFilters)) && (
                            <ChipItem
                                chipLabel='Question'
                                chipValue={filters.question}
                                onDelete={() => {
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        question: "",
                                    }));
                                }}
                            />
                        )}
                    {filters.priority > 0 &&
                        (filtersIndex <= filtersLimit ||
                            (filtersIndex > filtersLimit && showFilters)) && (
                            <ChipItem
                                chipLabel='Priority'
                                chipValue={priorityList.find(x => x.id === filters.priority)?.name}
                                onDelete={() => {
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        priority: 0,
                                    }));
                                }}
                            />
                        )}

                    {filters.categoryId &&
                        (filtersIndex <= filtersLimit ||
                            (filtersIndex > filtersLimit && showFilters)) && (
                            <ChipItem
                                chipLabel='Category Id'
                                chipValue={ faqsCategoryData?.find(x => x.id === filters?.categoryId )?.name }
                                onDelete={() => {
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        categoryId: "",
                                    }));
                                }}
                            />
                        )}

                    <SelectedChiptItems
                        selectedItems={filters.platForm}
                        items={platformOptions}
                        setFilters={setFilters}
                        filtersIndex={filtersIndex}
                        filtersLimit={filtersLimit}
                        showFilters={showFilters}
                        field={"platForm"}
                        chipLabel={"Platform"}
                    />

                    <div
                        style={{
                            textAlign: "right",
                        }}>
                        {filtersCount > filtersLimit && (
                            <IconButton
                                color={"primary"}
                                onClick={() => setShowFilter(!showFilters)}>
                                <MoreHoriz />
                            </IconButton>
                        )}
                    </div>
                </Accordion>
                <div className='userDetailsSearchField inputWrapper filterSelect'>
                    {/* <InputField
                        id='question'
                        name='question'
                        placeholder={"Question"}
                        value={filters.question}
                        onChange={({ target }) =>
                            setFilters(prevFilters => ({
                                ...prevFilters,
                                question: target.value,
                            }))
                        }
                    /> */}

                    <AutoComplete
                        value={ faqsCategoryData?.filter(x=>x.id === filters?.categoryId)?.name }
                        onChange={(event, value) => {
                            setFilters(prevFilters => ({
                                ...prevFilters,
                                categoryId: value.id,
                            }));
                        }}
                        id='categoryId'
                        options={faqsCategoryData}
                        getOptionLabel={option => option?.name || ""}
                        placeholder={"FAQs Category"}
                    />
                    <div style={{marginTop:"5px"}}></div>
                    <AutoComplete
                        value={priorityList?.find(x => x.id === filters?.priority)?.label}
                        onChange={(event, value) => {
                            setFilters(prevFilters => ({
                                ...prevFilters,
                                priority: value.id,
                            }));
                        }}
                        id='categoryId'
                        options={priorityList}
                        getOptionLabel={option => option?.name || ""}
                        placeholder={"Priority"}
                    />
                    <div style={{marginTop:"5px"}}></div>

                    <FilterAutoComplete
                        value={platformOptions?.filter(eg => filters?.platForm?.includes(eg.id))}
                        onChange={(event, value) => {
                            setFilters(prevFilters => ({
                                ...prevFilters,
                                platForm: value.map(v => v.id)
                            }));
                        }}
                        id='Platform'
                        options={platformOptions}
                        getOptionLabel={option => option?.value || ""}
                        placeholder={"Platform"}
                        selectedFilter={filters.platForm?.length}
                    />

                </div>
            </GridSearchFilter>

            <h2 className='gridInnerHeading'>
                All FAQs
                <span className='gridTopPagination'>
                    <Pagination
                        recordCount={totalCount}
                        page={page - 1}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        rowsPerPageOptions={[]}
                        backIconButtonProps={{ style: { display: "none" } }}
                        nextIconButtonProps={{ style: { display: "none" } }}
                    />
                </span>
            </h2>
            <FAQuesGrid
                faqsData={faqsData}
                order={order}
                onOrderBy={setOrderBy}
                page={page}
                onDeleteFaq={onDeleteFaq}
            />
            <Pagination
                recordCount={totalCount}
                page={page - 1}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </div>
    );
};
export { FAQDataView };
